var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2287_14264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.6665V9.99984M10.0001 13.3332H10.0084M1.66675 7.10212V12.8976C1.66675 13.1014 1.66675 13.2033 1.68977 13.2992C1.71019 13.3842 1.74386 13.4655 1.78955 13.5401C1.84108 13.6242 1.91315 13.6962 2.05727 13.8404L6.15956 17.9426C6.30368 18.0868 6.37575 18.1588 6.45984 18.2104C6.5344 18.2561 6.61569 18.2897 6.70072 18.3101C6.79663 18.3332 6.89854 18.3332 7.10237 18.3332H12.8978C13.1016 18.3332 13.2035 18.3332 13.2994 18.3101C13.3845 18.2897 13.4658 18.2561 13.5403 18.2104C13.6244 18.1588 13.6965 18.0868 13.8406 17.9426L17.9429 13.8404C18.087 13.6962 18.1591 13.6242 18.2106 13.5401C18.2563 13.4655 18.29 13.3842 18.3104 13.2992C18.3334 13.2033 18.3334 13.1014 18.3334 12.8976V7.10212C18.3334 6.8983 18.3334 6.79638 18.3104 6.70048C18.29 6.61545 18.2563 6.53416 18.2106 6.4596C18.1591 6.3755 18.087 6.30344 17.9429 6.15931L13.8406 2.05703C13.6965 1.9129 13.6244 1.84084 13.5403 1.7893C13.4658 1.74361 13.3845 1.70994 13.2994 1.68953C13.2035 1.6665 13.1016 1.6665 12.8978 1.6665H7.10237C6.89854 1.6665 6.79663 1.6665 6.70072 1.68953C6.61569 1.70994 6.5344 1.74361 6.45984 1.7893C6.37575 1.84084 6.30368 1.9129 6.15956 2.05703L2.05727 6.15931C1.91315 6.30344 1.84108 6.3755 1.78955 6.4596C1.74386 6.53416 1.71019 6.61545 1.68977 6.70048C1.66675 6.79638 1.66675 6.8983 1.66675 7.10212Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2287_14264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalRequired);
export default __webpack_public_path__ + "static/media/approval-required.419b4cc36eae4b82419598e3af926732.svg";
export { ForwardRef as ReactComponent };